<template>
  <div class="index">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row">
              <div class="col-sm-12">
                <h3 class="page-title">Employee Onboarding df</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item active">Dashboard</li>
                </ul>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="card mb-0">
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="profile-view">
                    <div class="profile-img-wrap">
                      <div class="profile-img">
                        <a
                          ><img
                            alt=""
                            :src="media + employee.passportPhoto"
                            v-if="employee.passportPhoto"/>
                          <img
                            alt=""
                            src="~@/assets/profiles/avatar-02.jpg"
                            v-if="!employee.passportPhoto"
                        /></a>
                      </div>
                    </div>
                    <div class="profile-basic">
                      <div class="row">
                        <div class="col-md-5">
                          <div class="profile-info-left">
                            <h3 class="user-name m-t-0 mb-0">
                              {{ employee.firstName + " " + employee.lastName }}
                            </h3>
                            <h6 class="text-muted">
                              {{ employee.designation.name }}
                            </h6>
                            <small class="text-muted">{{
                              employee.designation.department.name
                            }}</small>
                            <div class="staff-id">
                              Employee ID :
                              {{ company.abbrv + "-" + employee.id }}
                            </div>
                            <div class="small doj text-muted">
                              Date of Join :
                              {{
                                new Date(
                                  employee.createdAt
                                ).toLocaleDateString()
                              }}
                            </div>
                            <!-- <div class="staff-msg">
                              <router-link to="/chat" class="btn btn-custom"
                                >Send Message
                              </router-link>
                            </div> -->
                          </div>
                        </div>
                        <div class="col-md-7">
                          <ul class="personal-info">
                            <li>
                              <div class="title-label">Phone:</div>
                              <div class="text">
                                {{ employee.phone }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Email:</div>
                              <div class="text">
                                <a href="">{{ employee.email }}</a>
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Birthday:</div>
                              <div class="text">
                                {{
                                  new Date(
                                    employee.birthday
                                  ).toLocaleDateString()
                                }}
                              </div>
                            </li>
                            <li>
                              <div class="title-label">Address:</div>
                              <div class="text">{{ employee.address }}</div>
                            </li>
                            <li>
                              <div class="title-label">Gender:</div>
                              <div class="text">{{ employee.gender }}</div>
                            </li>
                            <li>
                              <div class="title-label">Reports to:</div>
                              <div class="text" v-if="employee.employeeManager">
                                <div class="avatar-box">
                                  <div class="avatar avatar-xs">
                                    <img
                                      alt=""
                                      :src="
                                        media +
                                          employee.employeeManager.manager
                                            .passportPhoto
                                      "
                                      v-if="
                                        employee.employeeManager.manager
                                          .passportPhoto
                                      "
                                    />
                                    <img
                                      alt=""
                                      src="~@/assets/profiles/avatar-02.jpg"
                                      v-if="
                                        !employee.employeeManager.manager
                                          .passportPhoto
                                      "
                                    />
                                  </div>
                                </div>
                                <router-link
                                  :to="{
                                    name: 'employeedetail',
                                    params: { id: employee.employeeManager.id }
                                  }"
                                  >{{
                                    employee.employeeManager.manager.firstName +
                                      " " +
                                      employee.employeeManager.manager.lastName
                                  }}</router-link
                                >
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                    <div class="pro-edit"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <hr />
          <div id="emp_profile" class="pro-overview tab-pane fade show active">
            <div class="row">
              <div class="col-md-6 d-flex">
                <div class="col-md-12 d-flex">
                  <div class="card flex-fill">
                    <div class="card-body">
                      <form>
                        <input
                          class="form-control card-title col-md-12"
                          value="Welcome to Company"
                        />
                        <quill-editor
                          v-model="employee.onboarding.welcomeGuide"
                          ref="myQuillEditor"
                        >
                        </quill-editor>
                        <div class="submit-section">
                          <a
                            class="btn btn-primary submit-btn"
                            @click="onSubmit"
                            >Submit</a
                          >
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row col-md-6 d-flex">
                <div class="col-md-12 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <h3 class="col-md-10">
                          Activities
                        </h3>
                        <div class="col-md-2 float-right ml-auto">
                          <a class="edit-icon" @click="openActivityDialog">
                            <i class="fa fa-plus"></i>
                          </a>
                        </div>
                        <!-- <div class="col-auto float-right ml-auto">
                                <a class="btn add-btn btn-small">
                                    <i class="fa fa-plus"></i>
                                </a>
                            </div> -->
                      </div>

                      <ul class="list-group list-group-flush" id="accordion">
                        <li
                          class="list-group-item py-0 px-0"
                          v-for="item in employee.employeeActivities"
                          :key="item.id"
                        >
                          <div class="row align-items-center">
                            <div class="col-md-1 float-right ml-auto">
                              <a @click="removeActivity(item)">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>

                            <div class="col-md-7">
                              {{ item.activity.name }}
                            </div>

                            <div class="col-md-3">
                              {{ new Date(item.dueDate).toLocaleDateString() }}
                            </div>

                            <div class="col-md-1">
                              <label class="col-form-label">
                                <div class="dropdown">
                                  <button
                                    class="dropdown-toggle"
                                    @click="toggle($event)"
                                  ></button>
                                </div>
                              </label>
                            </div>
                          </div>
                          <div class="collapse">
                            <div class="card-body">
                              {{ item.activity.document }}
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <div class="row align-items-center">
                        <h3 class="col-md-10">
                          Resources
                        </h3>
                        <div class="col-md-2 float-right ml-auto">
                          <a class="edit-icon" @click="openResourceDialog">
                            <i class="fa fa-plus"></i>
                          </a>
                        </div>
                        <!-- <div class="col-auto float-right ml-auto">
                                <a class="btn add-btn btn-small">
                                    <i class="fa fa-plus"></i>
                                </a>
                            </div> -->
                      </div>
                      <ul class="list-group list-group-flush">
                        <li
                          class="list-group-item py-0 px-0"
                          v-for="item in employee.employeeResources"
                          :key="item.id"
                        >
                          <div class="row align-items-center">
                            <div class="col-md-1 float-right ml-auto">
                              <a @click="removeResource(item)">
                                <i class="fa fa-trash"></i>
                              </a>
                            </div>
                            <div class="col-md-10">
                              {{ item.resource.name }}
                            </div>
                            <div class="col-md-1">
                              <label class="col-form-label">
                                <div class="dropdown">
                                  <button
                                    class="dropdown-toggle"
                                    @click="toggle($event)"
                                  ></button>
                                </div>
                              </label>
                            </div>
                          </div>
                          <div class="collapse">
                            <div class="card-body">
                              <button
                                type="button"
                                class="btn btn-secondary"
                                v-if="item.resource.document"
                                @click="
                                  getResourceDocument(item.resource.document)
                                "
                              >
                                Download Resource
                              </button>
                            </div>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- <div class="row">
                <div class="col-md-6 d-flex">
                  <div class="card profile-box flex-fill">
                    <div class="card-body">
                      <h3 class="card-title">
                        
                        <div class="row align-items-center">
                          <div class="col-md-1">
                              <input 
                                type="checkbox" 
                              />
                          </div>
                      
                          <div class="col-md-7">
                              Activity Name
                          </div>

                          <div class="col-md-2">
                              Date
                          </div>
                      
                          <div class="col-md-2">
                            <label class="col-form-label">
                                <div class="dropdown edit-icon">
                                    <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false"></a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#">Action</a>
                                        <a class="dropdown-item" href="#">Another</a>
                                    </div>
                                </div>
                            </label>
                          </div>
                            
                        </div>
                      </h3>
                      <div class="card-title">
                        
                        <div class="row align-items-center">
                          <div class="col-md-1">
                              <input 
                                type="checkbox" 
                              />
                          </div>
                      
                          <div class="col-md-7">
                              Activity Name
                          </div>

                          <div class="col-md-2">
                              Date
                          </div>
                      
                          <div class="col-md-2">
                            <label class="col-form-label">
                                <div class="dropdown edit-icon">
                                    <a class="dropdown-toggle" href="#" role="button" data-toggle="dropdown" aria-expanded="false"></a>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#">Action</a>
                                        <a class="dropdown-item" href="#">Another</a>
                                    </div>
                                </div>
                            </label>
                          </div>
                            
                        </div>
                      </div>
                      <ul class="personal-info">
                          <div class="col-md-1"></div>
                          <div class="col-md-11">
                            <h3 class="title">Description </h3> 
                          </div>
                      </ul>
                    </div>
                  </div>
                </div>

              </div> -->
          </div>
        </div>

        <!-- Add Activity Modal -->
        <v-dialog v-model="dialogActivity" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Activity</h5>
              <button type="button" class="close" @click="closeActivityDialog">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Activity <span class="text-danger">*</span></label>
                <select
                  placeholder="Select Activity"
                  class="form-control"
                  v-model="activity"
                >
                  <option disabled value="">Select Activity</option>
                  <option
                    v-for="item in activities"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ `${item.name}` }}
                  </option>
                </select>
              </div>
              <div class="form-group">
                <label>Due Date <span class="text-danger">*</span></label>
                <div class="cal-icon">
                  <datepicker
                    v-model="dueDate"
                    calendar-class
                    input-class
                    bootstrap-styling
                    class="form-control datetimepicker"
                    type="text"
                  />
                </div>
              </div>
              <div class="submit-section">
                <button
                  @click.prevent="onSubmitActivity"
                  data-dismiss="modal"
                  class="btn btn-primary submit-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          <!-- </div>
        </div> -->
        </v-dialog>
        <!-- /Add Activity Modal -->
        <!-- Add Resource Modal -->
        <v-dialog v-model="dialogResource" max-width="725px">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Add Resource</h5>
              <button type="button" class="close" @click="closeResourceDialog">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <label>Resource <span class="text-danger">*</span></label>
                <select
                  placeholder="Select Resource"
                  class="form-control"
                  v-model="resource"
                >
                  <option disabled value="">Select Resource</option>
                  <option
                    v-for="item in resources"
                    :key="item.id"
                    :value="item.id"
                  >
                    {{ `${item.name}` }}
                  </option>
                </select>
              </div>
              <div class="submit-section">
                <button
                  @click.prevent="onSubmitResource"
                  data-dismiss="modal"
                  class="btn btn-primary submit-btn"
                >
                  Submit
                </button>
              </div>
            </div>
          </div>

          <!-- </div>
        </div> -->
        </v-dialog>
        <!-- /Add Resource Modal -->
        <!-- /Page Content -->
      </div>
    </div>
    <!-- /Page Wrapper -->
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { employeeService } from "@/services/employeeService";
import { skillsService } from "@/services/skillsService";
import { authenticationService } from "@/services/authenticationService";
import { organizationService } from "@/services/organizationService";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },
  data() {
    return {
      media: "data:image/jpeg;base64,",
      dialogActivity: false,
      dialogResource: false,
      employee: {
        firstName: null,
        gender: "",
        id: this.$route.params.id,
        lastName: "",
        maritalStatus: null,
        nationality: null,
        passportIdentificationNumber: null,
        passportPhoto: null,
        phone: "",
        religion: null,
        onboarding: {},
        employeeActivities: [],
        employeeResources: []
      },
      activities: [],
      resources: [],
      activity: null,
      resource: null,
      dueDate: new Date(),
      company: authenticationService.currentOfficeValue,
      currentUser: authenticationService.currentUserValue
    };
  },
  mounted() {
    this.getHire();
    this.getActivities();
    this.getResources();

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
  },
  methods: {
    openActivityDialog() {
      this.dialogActivity = true;
    },
    openResourceDialog() {
      this.dialogResource = true;
    },
    closeActivityDialog() {
      this.dialogActivity = false;
    },
    closeResourceDialog() {
      this.dialogResource = false;
    },
    getResourceDocument(file) {
      organizationService.getPolicyDocument(file).then(
        response => {
          let blob = new Blob([response.data], { type: response.data.type });
          // For the processing of the IE browser, CreateObjectURL is not supported by some IE browser
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob, response.fileName);
          } else {
            var downloadElement = document.createElement("a");
            var href = window.URL.createObjectURL(blob); // Create a download link
            downloadElement.href = href;
            downloadElement.download = response.fileName; // Download the file name
            document.body.appendChild(downloadElement);
            downloadElement.click(); // click to download
            document.body.removeChild(downloadElement); // Download complete removal element
            window.URL.revokeObjectURL(href); // Release Blob object
          }
        },
        error => {
          error = error;
        }
      );
    },
    removeActivity(item) {
      if (confirm("Are you sure you want to delete " + item.activity.name)) {
        employeeService.removeEmployeeActivity(item.id).then(p => {
          this.getHire();
        });
      }
    },
    removeResource(item) {
      if (confirm("Are you sure you want to delete " + item.resource.name)) {
        employeeService.removeEmployeeResource(item.id).then(p => {
          this.getHire();
        });
      }
    },
    toggle(event) {
      var e = event.target;
      e.classList.toggle("active");
      var p = e.parentElement.parentElement.parentElement.parentElement;
      var content = p.nextElementSibling;
      if (content.style.display === "block") {
        content.style.display = "none";
      } else {
        content.style.display = "block";
      }
    },
    getActivities() {
      skillsService.getActivities(this.company.id).then(
        model => {
          this.activities = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getResources() {
      skillsService.getResources(this.company.id).then(
        model => {
          this.resources = model;
          console.log(model);
        },
        error => {
          error = error;
        }
      );
    },
    getHire() {
      employeeService.getHire(this.$route.params.id).then(p => {
        this.employee = p;
        this.activity = null;
        this.resource = null;
        this.dueDate = null;
      });
    },

    onSubmitActivity() {
      if (!this.activity || !this.dueDate) {
        return;
      }

      employeeService
        .addEmployeeActivity(this.employee.id, this.activity, this.dueDate)
        .then(p => {
          this.getHire();
          this.closeActivityDialog();
        });
    },

    onSubmit() {
      // console.log(this.employee.onboarding.welcomeGuide);
      employeeService
        .UpdateEmployeeOnboarding(this.employee.id, this.employee.onboarding)
        .then(p => {
          this.getHire();
        });
    },

    onSubmitResource() {
      if (!this.resource) {
        return;
      }

      employeeService
        .addEmployeeResource(this.employee.id, this.resource)
        .then(p => {
          this.getHire();
          this.closeResourceDialog();
        });
    }
  },
  name: "onboardingedit"
};
</script>



// WEBPACK FOOTER //
// src/components/employees/onboardingedit.vue